import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { Share2, Save } from "lucide-react";
import { SOCIALS } from "@/lib/socials";

export default function SocialSettings() {
  const [form, setForm] = useState({});
  const [saving, setSaving] = useState(false);
  useEffect(() => { api.get("/settings/social").then((r) => setForm(r.data)).catch(() => {}); }, []);

  const save = async () => {
    setSaving(true);
    try { const { data } = await api.put("/admin/settings/social", form); setForm(data); toast.success("Réseaux sociaux enregistrés"); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    setSaving(false);
  };

  return (
    <section data-testid="social-settings" className="bg-white border border-gray-200 p-6 space-y-4">
      <h3 className="font-display text-lg font-semibold text-[#1B2A4A] flex items-center gap-2"><Share2 className="w-5 h-5 text-[#E0C173]" /> Réseaux sociaux</h3>
      <p className="text-sm text-[#475569]">Seuls les réseaux renseignés s'affichent dans le pied de page du site. Laissez vide pour masquer une icône.</p>
      <div className="grid md:grid-cols-2 gap-4">
        {SOCIALS.map(({ key, label, Icon, placeholder }) => (
          <label key={key} className="flex items-center gap-3">
            <span className="w-10 h-10 shrink-0 rounded-full bg-[#1B2A4A] text-[#E0C173] flex items-center justify-center"><Icon className="w-4 h-4" /></span>
            <span className="flex-1">
              <span className="block text-xs uppercase tracking-wider text-[#475569]">{label}</span>
              <Input data-testid={`social-${key}`} value={form[key] || ""} onChange={(e) => setForm({ ...form, [key]: e.target.value })} placeholder={placeholder} className="rounded-none mt-1 border-gray-300" />
            </span>
          </label>
        ))}
      </div>
      <button data-testid="social-save" onClick={save} disabled={saving} className="inline-flex items-center gap-2 bg-[#1B2A4A] hover:bg-[#2a3d63] text-white px-5 py-2.5 text-sm disabled:opacity-50">
        <Save className="w-4 h-4" /> {saving ? "Enregistrement…" : "Enregistrer les réseaux"}
      </button>
    </section>
  );
}
